module.exports = __webpack_public_path__ + "static/img/market_operation.084662b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource_10_23/market_operation.jpg
// module id = mJCD
// module chunks = 1